module.exports = __webpack_public_path__ + "img/show-on-map.df2a5182.svg";